import { ToggleButton } from 'vue-js-toggle-button';
import SectorService from '../../services/Sector.js';
import CountryService from '../../services/Country.js';
import ProfileTypeService from '../../services/ProfileType.js';
import UserSourceService from '../../services/UserSource.js';
import Helper from '../../Helper.js';
import EditorJquery from './EditorJquery.js';
import RadialProgressBar from 'vue-radial-progress';
import moment from 'moment';

if($('#component-user-editor').length){
    var app = new Vue({
        el: '#component-user-editor',
        data: {
            user: {
                sectors:[]
            },
            loading:true,
            sidebar:true,
            profileDetails:true,
            additionalDetails:false,
            accountSettings:false,
            showOptions:false,
            media:false,
            createdModal: true,
            justCreated: false,
            completedSteps: 0,
            totalSteps: 0,
            profileDetailsCompletedSteps: 0,
            profileDetailsTotalSteps: 0,
            additionalDetailsCompletedSteps: 0,
            additionalDetailsTotalSteps: 0,
            uploaderErrors:[],
            sectors:[],
            countries:[],
            profileTypes:[],
            userSources:[],
            radialColour:'#5B45E0',
            radialWidth:5,
            radialInnerColor:'#E0E0E0',
            loadingMessage:'Loading Profile Editor',
            currentUserId: currentUserId,
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            applicationId: applicationId,
            Helper: Helper,
            EditorJquery: EditorJquery,
            moment: moment,
            awsUrl: awsUrl,
            privateOrganisation: privateOrganisation,
            showUploadMedia: false,
            dataImages: [],
            targetId: '',
            imageMedia: false,
            bannerMedia: false,
            logoMedia: false,
            showSectors: false,
            announcementSectorsCount: 0,
            disabled: false,
            step: currentStep,
            step_1: false,
            step_2: false,
            step_3: false,
            request: request
        },
        methods: {
            getUser(){
                axios.get('/api/v1/user')
                .then((response) =>  {
                    this.user = response.data;
                    this.user.image_location = this.user.image
                    this.postLoad();
                })
                .catch((error) =>  {
                    this.errorHandler(error);
                })
            },
            saveUser(applying = false){
                var regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(this.user.password);
                this.stepsCalculation();

                if(this.profileDetailsCompletedSteps != this.profileDetailsTotalSteps){
                    this.$toasted.error("You must complete all fields in the 'Profile Details' section before you can save");
                    $('#editor-sidebar').submit();
                    return false;
                }

                /*if(networkSlug){
                    //do nothing
                }else if((this.user.password && this.user.password != this.user.password_confirmation) || (!regex && this.user.password)){
                    this.$toasted.error("There was an issue with your password please check that both passwords match");
                    $('#editor-sidebar').submit();
                    return false;
                }*/

                if(applying && (this.totalSteps != this.completedSteps)){
                    this.$toasted.error("Your profile must be 100% complete which includes filling in all non optional fields in the 'Profile Details' section and 'Additional Details' section before you may continue your application");
                    return false;
                }

                // var form =  document.getElementById('editor-sidebar');
                var formData = new FormData();
                formData = this.appendFields(formData);
                
                this.loading = true;
                this.loadingMessage = 'Saving User';

                axios.post('/api/v1/user', formData)
                .then((response) =>  {
                    if(this.applicationId && applying){
                        window.location.replace("/organisation/"+this.networkGroupSlug+"/"+this.networkSlug+"/apply/expert/"+this.applicationId+"/review");
                        return;
                    }

                    if(applying){
                        window.location.replace("/organisation/"+this.networkGroupSlug+"/"+this.networkSlug+"/apply/expert/vetting/"+response.data.id+"/create");
                        return;
                    }

                    this.user = response.data;

                    this.postLoad();

                    this.$toasted.success('Your Profile has been Saved.');
                })
                .catch((error) =>  {
                    this.errorHandler(error);
                });
            },
            saveNotifications() {
                this.disabled = true;
                // var form = document.getElementById('notifications-editor');
                var formData = new FormData();
                formData = this.appendNotificationsFields(formData);

                axios.post('/api/v1/user/notifications', formData)
                    .then((response) => {
                        this.disabled = false;
                        this.user = response.data;
                        this.$toasted.success('Your Notifications settings has been Saved.');
                    })
                    .catch((error) => {
                        this.disabled = false;
                        this.errorHandler(error);
                    });
            },
            appendFields(formData) {
                formData.append('password', this.user.password);
                formData.append('password_confirmation', this.user.password_confirmation ? this.user.password_confirmation : '');
                formData.append('first_name', this.user.first_name ? this.user.first_name : '');
                formData.append('last_name', this.user.last_name ? this.user.last_name : '');
                formData.append('organisation', this.user.organisation ? this.user.organisation : '');
                formData.append('job_title', this.user.job_title ? this.user.job_title : '');
                formData.append('expert_short_description', this.user.expert_short_description ? this.user.expert_short_description : '');
                formData.append('expert_long_description', this.user.expert_long_description ? this.user.expert_long_description : '');
                formData.append('country_id', this.user.country_id ? this.user.country_id : '');
                formData.append('language_id', this.user.language_id ? this.user.language_id : '');
                formData.append('profile_type_id', this.user.profile_type_id ? this.user.profile_type_id : '');
                formData.append('user_source_id', this.user.user_source_id ? this.user.user_source_id : '');
                formData.append('expert_primary_sector_id', this.user.expert_primary_sector_id ? this.user.expert_primary_sector_id : '');
                formData.append('expert_field_of_expertise', this.user.expert_field_of_expertise ? this.user.expert_field_of_expertise : '');
                formData.append('phone_number', this.user.phone_number ? this.user.phone_number : '');
                formData.append('pronouns', this.user.pronouns ? this.user.pronouns : '');
                formData.append('user_type', this.user.user_type ? this.user.user_type : '');

                formData.append('private', this.user.private ? 1 : 0);
                formData.append('from_private_organisation', this.user.from_private_organisation ? 1 : 0);

                formData.append('total', this.totalSteps);
                formData.append('completed', this.completedSteps);

                if(this.totalSteps == this.completedSteps){
                    formData.append('expert', 1);
                    formData.append('expert_status_id', 1);
                }else{
                    formData.append('expert', 0);
                    formData.append('expert_status_id', 2);
                }
                formData.append('sectors', this.user.sectors && this.user.sectors.length > 0 ? this.user.sectors : '');

                if ((!this.user.id && !this.user.image_location_file) || this.imageMedia === true) {
                    formData.append('image_location', this.user.image_location.replace("//" + this.awsUrl + "/", ""));
                    this.imageMedia = false;
                } else if (this.user.image_location_file) {
                    formData.append('image_location', this.user.image_location_file);
                }
                if ((!this.user.id && !this.user.header_banner_image_file) || this.bannerMedia === true) {
                    formData.append('header_banner_image', this.user.header_banner_image.replace("//" + this.awsUrl + "/", ""));
                    this.bannerMedia = false;
                } else if (this.user.header_banner_image_file) {
                    formData.append('header_banner_image', this.user.header_banner_image_file);
                }
                if ((!this.user.id && !this.user.company_image_location_file) || this.logoMedia === true) {
                    formData.append('company_image_location', this.user.company_image_location.replace("//" + this.awsUrl + "/", ""));
                    this.logoMedia = false;
                } else if (this.user.company_image_location_file) {
                    formData.append('company_image_location', this.user.company_image_location_file);
                }

                formData.append('_method', 'PATCH');

                return formData;
            },
            appendNotificationsFields(formData) {
                formData.append('receive_automated_notification_emails', this.user.receive_automated_notification_emails ? 1 : 0);
                formData.append('receive_direct_message_notification_emails', this.user.receive_direct_message_notification_emails ? 1 : 0);
                formData.append('receive_announcement_notification_emails', this.user.receive_announcement_notification_emails ? 1 : 0);
                formData.append('announcementSectors', this.user.announcementSectors && this.user.announcementSectors.length > 0 ? this.user.announcementSectors : '');
                formData.append('receive_type_email', this.user.receive_type_email ? 1 : 0);
                formData.append('newsletter', this.user.newsletter ? 1 : 0);

                return formData;
            },
            sectorChange(){
                var sectorID = this.user.expert_primary_sector_id;
                var sector = this.sectors.filter(obj => {
                    return obj.id === sectorID;
                });
                if((this.user.header_banner_image.indexOf("sector/") !== -1 || this.user.header_banner_image.indexOf("6f12c9aefa0d6bb1932da064f934af85") !== -1) && !this.user.header_banner_image_file){
                    this.user.header_banner_image = sector[0].image_location;
                }
            },
            previewLogoImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.user.image_location = fileBlob;
                    this.user.image_location_file = file;
                    this.showUploadMedia = false;
                }
            },
            previewCompanyImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.user.company_image_location = fileBlob;
                    this.user.company_image_location_file = file;
                    this.showUploadMedia = false;
                }
            },
            previewBannerImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.user.header_banner_image = fileBlob;
                    this.user.header_banner_image_file = file;
                    this.showUploadMedia = false;
                }
            },
            addhttp(url) {
                if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
                    url = "http://" + url;
                }
                return url;
            },
            postLoad() {
                this.$nextTick(function () {
                    this.loading = false;
                    if (this.user.announcementSectors) {
                        this.announcementSectorsCount = this.user.announcementSectors.length
                    }
                    EditorJquery.jqueryHelpers();
                });
            },
            stepsCalculation(){
                let user = this.user;
                this.profileDetailsCompletedSteps = 0;
                this.additionalDetailsCompletedSteps = 0;

                user.first_name ? this.profileDetailsCompletedSteps++ : null; 
                user.last_name ? this.profileDetailsCompletedSteps++ : null; 
                user.organisation ? this.profileDetailsCompletedSteps++ : null; 
                user.email ? this.profileDetailsCompletedSteps++ : null; 
                user.job_title ? this.profileDetailsCompletedSteps++ : null; 
                user.country_id ? this.profileDetailsCompletedSteps++ : null; 
                this.profileDetailsTotalSteps = 6;

                user.expert_primary_sector_id ? this.additionalDetailsCompletedSteps++ : null;
                user.expert_field_of_expertise ? this.additionalDetailsCompletedSteps++ : null;
                user.expert_short_description ? this.additionalDetailsCompletedSteps++ : null;
                user.expert_long_description ? this.additionalDetailsCompletedSteps++ : null;
                this.additionalDetailsTotalSteps = 4;

                this.completedSteps = this.profileDetailsCompletedSteps + this.additionalDetailsCompletedSteps;
                this.totalSteps = this.profileDetailsTotalSteps + this.additionalDetailsTotalSteps;
            },
            removeFromPrivateOrganisation(){
                $('.tooltipped').tooltip('close');
                this.user.from_private_organisation = false;
                this.saveUser();
            },
            errorHandler(error){
                if(typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    let errors = error.response.data.errors;
                    if (errors !== undefined && errors.length > 0) {
                        for (let field of Object.keys(errors)) {
                            this.$toasted.error(errors[field][0]);
                        }
                    }
                }
                this.loading = false;
            },
            justCreatedCheck(){
                if(window.location.href.indexOf('justCreated') != -1){
                    this.justCreated = true;
                }else{
                    this.justCreated = false;
                }
            },
            hideOptions(e){
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.showOptions = false;
                    }, 100);
                });
            },
            uploadMedia(id) {
                this.getUploadedMedia();
                this.targetId = id;
                this.showUploadMedia = true;
            },
            getUploadedMedia() {
                axios.get('/api/v1/get-uploaded-media')
                    .then((response) => {
                        if (response.data.hasOwnProperty('uploads')) {
                            this.dataImages = response.data.uploads;
                        }
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    })
            },
            onSelectImage(data) {
                if (this.targetId === 'image') {
                    this.user.image_location = data.src;
                    this.imageMedia = true;
                } else if (this.targetId === 'banner') {
                    this.user.header_banner_image = data.src;
                    this.bannerMedia = true;
                } else if (this.targetId === 'logo') {
                    this.user.company_image_location = data.src;
                    this.logoMedia = true;
                }
                this.showUploadMedia = false;
            },
            selectMethod(result, files) {
                if (result == 'EXTENSION_ERROR') {
                    this.$toasted.error('The selected image contain invalid extension.');
                    return;
                } else if (result == 'FILE_SIZE_ERROR') {
                    this.$toasted.error('The selected image size exceeded limit.');
                    return;
                }
                if (files && files[0]) {
                    let file = files[0], vm = this, img = new Image();
                    img.onload = function () {
                        if (this.width > 3000 || this.height > 3000) {
                            vm.$toasted.error('The selected image dimensions exceeded limit (3000*3000).');
                        } else {
                            if (vm.targetId === 'image') {
                                vm.previewLogoImage(img.src, file);
                            } else if (vm.targetId === 'banner') {
                                vm.previewBannerImage(img.src, file);
                            } else if (vm.targetId === 'logo') {
                                vm.previewCompanyImage(img.src, file);
                            }
                        }
                    }
                    img.src = URL.createObjectURL(file);
                }
            },
            requiredFields() {
                if (!this.user.first_name) {
                    this.$toasted.error('First Name required');
                }
                if (!this.user.last_name) {
                    this.$toasted.error('Last Name required');
                }
                if (!this.user.organisation) {
                    this.$toasted.error('Organisation required');
                }
                if (!this.user.job_title) {
                    this.$toasted.error('Job Title required');
                }
                if (!this.user.country_id) {
                    this.$toasted.error('Location required');
                }
            },
            nextStep() {
                this.requiredFields();

                if (this.user.first_name && this.user.last_name && this.user.organisation &&
                    this.user.job_title && this.user.country_id) {
                    this.createStep(2);
                }
            },
            nextStep2() {
                this.requiredFields();

                if (!this.user.expert_primary_sector_id) {
                    this.$toasted.error('Primary Sector required');
                }
                if (!this.user.expert_field_of_expertise) {
                    this.$toasted.error('Field of Expertise required');
                }
                if (!this.user.expert_short_description) {
                    this.$toasted.error('Headline required');
                }
                if (!this.user.expert_long_description) {
                    this.$toasted.error('Expertise Description required');
                }

                if (this.user.image_location_file || this.imageMedia === true || this.user.header_banner_image_file || this.bannerMedia === true || this.user.company_image_location_file || this.logoMedia === true) {
                    this.$toasted.error("You need to hit 'Save' button otherwise your media changes will not be reflected.");
                } else if (this.user.first_name && this.user.last_name && this.user.organisation &&
                    this.user.job_title && this.user.country_id && this.user.expert_primary_sector_id &&
                    this.user.expert_field_of_expertise && this.user.expert_short_description && this.user.expert_long_description) {
                    this.createStep(3);
                }
            },
            createStep(step) {
                axios.post('/user/create/steps', {
                    'user': this.user,
                    'step': step
                })
                    .then((response) => {
                        if (location.href.includes("/apply-as")) {
                            location.replace(location.href);
                        } else {
                            this.reload();
                        }
                    })
                    .catch((error) => {
                        this.$toasted.error(error.response.data);
                    });
            },
            setUser() {
                this.user = this.request;
                this.loading = false;
                if (this.user.announcementSectors) {
                    this.announcementSectorsCount = this.user.announcementSectors.length
                }
                if (!this.user.profile_type_id) {
                    this.user.profile_type_id = '';
                }
                if (!this.user.country_id) {
                    this.user.country_id = '';
                }
                if (!this.user.expert_primary_sector_id) {
                    this.user.expert_primary_sector_id = '';
                }
            },
            showModal(name) {
                this.$modal.show(name);
            },
            onTextChange() {
                const quill = this.$refs.editor.quill
                const len = quill.getLength()
                if (len > 180) {
                    quill.deleteText(180, len);
                }
            },
            opened() {
                $(".tooltipped").tooltip();
            },
            changeEmail() {
                if (!this.user.new_email || !this.user.confirm_password) {
                    this.$toasted.error('Please fill out the required fields.');
                    return
                }
                if (this.user.new_email === this.user.email) {
                    this.$toasted.error('Please enter a new email address.');
                    return
                }
                this.loading = true;
                axios.post('/api/v1/user/change-email/' + this.user.id, {
                    new_email: this.user.new_email,
                    confirm_password: this.user.confirm_password
                })
                    .then((response) => {
                        this.loading = false;
                        if (response.data.error) {
                            this.$toasted.error(response.data.error);
                            return;
                        }
                        this.user = response.data;
                        this.postLoad();
                        this.$toasted.success('Your email has been changed.');
                        this.$modal.hide('email-modal');
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    });
            },
            changePassword() {
                if (!this.user.password || !this.user.new_password || !this.user.new_password_confirmation) {
                    this.$toasted.error('Please fill out the required fields.');
                    return
                }
                this.loading = true;
                axios.post('/api/v1/user/change-password/' + this.user.id, {
                    password: this.user.password,
                    new_password: this.user.new_password,
                    new_password_confirmation: this.user.new_password_confirmation
                })
                    .then((response) => {
                        this.loading = false;
                        if (response.data.error) {
                            this.$toasted.error(response.data.error);
                            return;
                        }
                        this.user = response.data;
                        this.postLoad();
                        this.$toasted.success('Your password has been changed.');
                        this.$modal.hide('password-modal');
                    })
                    .catch((error) => {
                        this.loading = false;
                        let msg = error.response.data.errors.new_password[0];
                        if (msg == 'The new password format is invalid.') {
                            msg = 'Must contain 8 characters, 1 Upper-case, 1 Lower-case and 1 number';
                        }
                        this.$toasted.error(msg);
                    });
            },
            reload() {
                location.replace('/dashboard/profile-details');
            }
        },
        mounted () {
            if (!this.request) {
                this.step_1 = true
            } else {
                this.step_1 = false;
                if (this.step == 2) {
                    this.step_3 = false;
                    this.step_2 = true;
                } else if (this.step == 3) {
                    this.step_2 = false;
                    this.step_3 = true;
                }
            }
            SectorService.getSectors().then(data => {
                this.sectors = data;
            });
            CountryService.getCountries().then(data => {
                this.countries = data;
            });
            ProfileTypeService.getProfileTypes().then(data => {
                this.profileTypes = data;
            });
            UserSourceService.getUserSources().then(data => {
                this.userSources = data;
            });

            this.stepsCalculation();

            if (userId) {
                if (this.request) {
                    this.setUser();
                } else {
                    this.getUser(userId);
                }
                this.justCreatedCheck();
                this.cardView = false;
            } else {
                if (this.request) {
                    this.setUser();
                }
                this.postLoad();
            }
        },
        updated: function () {
        },
        components: {
            'ToggleButton': ToggleButton,
            'SectorService': SectorService,
            'RadialProgressBar': RadialProgressBar
        },
        watch: {
            user: {
                handler(val){
                    this.stepsCalculation();
                },
                deep: true
            }
        }
    });
}